import React, { useState, forwardRef } from 'react';
import '../assets/css/SearchBar.css';
import search from '../assets/icons/delete.png'

const SearchBar = forwardRef(({ data, onSearch, placeholder, onKeyDown,
  showToggle = false, toggleOnIcon,
  toggleOffIcon, }, ref) => {

  const [isEnabled, setIsEnabled] = useState(true); // always start enabled
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (e) => {
    if (!isEnabled) return; // ignore input if disabled
    setSearchQuery(e.target.value);
    onSearch(e.target.value);
  };

  const handleToggle = () => {
    setIsEnabled((prev) => !prev);

    // Optional: clear search when disabling
    if (isEnabled) {
      setSearchQuery('');
      onSearch('');
    }
  };
  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-input"
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleSearchChange}
        onKeyDown={onKeyDown}
        disabled={!isEnabled}
        autoFocus
        ref={ref}
      />
      {!showToggle && <img src={search} className="searchicon" style={{ cursor: 'pointer', width: '20px', height: '20px', top: "20px" }} onClick={() => { setSearchQuery(''); onSearch(''); }}></img>}


      {/* Toggle switch */}
      {showToggle && (
        <div
          onClick={handleToggle}
          style={{
            position: 'absolute',
            right: '2px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {isEnabled
            ? toggleOnIcon || (
              // 🔁 fallback icon
              <svg viewBox="0 0 40 24" width="40" height="24">
                <rect x="0" y="0" width="40" height="24" rx="12" fill="#7F56DA" />
                <circle cx="28" cy="12" r="10" fill="white" />
              </svg>
            )
            : toggleOffIcon || (
              <svg viewBox="0 0 40 24" width="40" height="24">
                <rect x="0" y="0" width="40" height="24" rx="12" fill="#bbb" />
                <circle cx="12" cy="12" r="10" fill="white" />
              </svg>
            )}
        </div>
      )}

    </div>
  );
});

export default SearchBar;
